import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { BoxQuestionnaireStatus } from '../../../shared/enums';
import { PublicBoxQuestionnaireFileResponse } from './public-box-questionnaire-file.response';
import { PublicBoxQuestionnaireOrderResponse } from './public-box-questionnaire-order.response';
import { PublicBoxQuestionnaireContextOperationsResponse } from './public-box-questionnaire-context-operations.response';
import { PublicBoxQuestionnaireQuestionResponse } from './public-box-questionnaire-question.response';
import { PublicBoxRecommendedQuestionnaireResponse } from './public-box-recommended-questionnaire.response';

@jsonObject
export class PublicBoxQuestionnaireDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Boolean)
  public readonly isShown!: boolean;

  @jsonMember(String)
  public readonly status!: BoxQuestionnaireStatus;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly endDate!: Date;

  @jsonMember(PublicBoxQuestionnaireFileResponse)
  public readonly logo!: PublicBoxQuestionnaireFileResponse;

  @jsonMember(PublicBoxQuestionnaireOrderResponse)
  public readonly order!: PublicBoxQuestionnaireOrderResponse;

  @jsonMember(PublicBoxQuestionnaireContextOperationsResponse)
  public readonly contextOperations!: PublicBoxQuestionnaireContextOperationsResponse;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonArrayMember(PublicBoxQuestionnaireQuestionResponse)
  public readonly questions!: PublicBoxQuestionnaireQuestionResponse[];

  @jsonArrayMember(PublicBoxRecommendedQuestionnaireResponse)
  public readonly recommendedQuestionnaires!: PublicBoxRecommendedQuestionnaireResponse[];
}
